export const SET_EXERCISE_DETAILS_ID = "SET_EXERCISE_DETAILS_ID";
export const SET_EXERCISE_DETAILS_NAME = "SET_EXERCISE_DETAILS_NAME";
export const SET_EXERCISE_DETAILS_STEP = "SET_EXERCISE_DETAILS_STEP";
